const logoStyle = {
  textAlign: 'center',
  paddingTop: '40px',
  height: '150px',
};

export default {
  logoStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/Login/components/Logo/style.js